import typeStyleMap from 'lib/graph-vis/typeStyleMap';
import { ReactComponent as SvgImage } from '../../../public/images/svg/project.svg';
export const ProjectIcon = (props) => (
  <SvgImage
    height={props.height || 24}
    style={{ fill: typeStyleMap.projectNode.color }}
    {...props}
  />
);

export const ProjectTagIcon = (props) => (
  <span
    role="img"
    aria-label="project tag"
    className="anticon anticon-project-tag"
  >
    <SvgImage
      style={{ margin: '2px 0 -2px 0' }}
      height={15}
      fill={'antiquewhite'}
      {...props}
    />
  </span>
);

export default ProjectIcon;
